module.exports = __webpack_public_path__ + "img/money02.5e5ee80b.png";